import { render, staticRenderFns } from "./carregamentosForm.vue?vue&type=template&id=0fa87cd7"
import script from "./carregamentosForm.vue?vue&type=script&lang=js"
export * from "./carregamentosForm.vue?vue&type=script&lang=js"
import style0 from "./carregamentosForm.vue?vue&type=style&index=0&id=0fa87cd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports